export const routesColor = [
  "#CA3716",
  "#253CF4",
  "#5DD50B",
  "#B81486",
  "#C28F0A",
  "#7723E7",
  "#0AC223",
  "#D50B2A",
  "#145DB8",
  "#99CB0B",
  "#BC0AC2",
  "#16CA90",
  "#C2510A",
  "#3925F4",
  "#35B814",
  "#D50B6E",
  "#0A9AC2",
  "#CABD16",
  "#8C0BD5",
  "#0BD551",
  "#B81D14",
  "#0D44F2",
  "#6CC20A",
  "#CA16AA",
  "#0AC2AD",
  "#D5830B",
  "#642CE8",
  "#0BD50D",
  "#C20A3E",
  "#167DCA",
  "#A9C20A",
  "#B50BD5",
  "#14B86E",
  "#D5400B",
  "#252CF4",
  "#51CA16",
  "#C20A7B",
  "#0BC3D5",
  "#B89714",
  "#7C0CE9",
  "#0AC232",
  "#CA1624",
  "#0B52CB",
  "#90D50B",
  "#B814B0",
  "#0BD5A4",
  "#C2600A",
  "#5030E8",
  "#20C20A",
  "#D50B5E",
  "#1487B8",
  "#C1C20A",
  "#950BCB",
  "#16CA62",
  "#C2220A",
  "#2042F3",
  "#5EB814",
  "#D50BA2",
  "#0AC2BB",
  "#CA8F16",
  "#6A16F3",
  "#0BD51D",
  "#B81436",
  "#0B6FD5",
  "#9BC20A",
  "#BC16CA",
  "#0AC27E",
  "#D54F0B",
  "#3930E8",
  "#3DD50B",
  "#C20A6D",
  "#16ABCA",
  "#C2AC0A",
  "#880CDF",
  "#14B845",
  "#D50C0B",
  "#0C49DF",
  "#7FCA16",
  "#C20AAA",
  "#0BD5B4",
  "#B86D14",
  "#5925F4",
  "#11C20A",
  "#CA1652",
  "#0A7DC2",
  "#BBCB0B",
  "#9614B8",
  "#0BD571",
  "#C2310A",
  "#303FE8",
  "#4FC20A",
  "#D50B92",
  "#14B1B8",
  "#D5A30B",
  "#760DF2",
  "#16CA35",
  "#C20A21",
  "#0B5FD5",
  "#88B814",
  "#0BD3D5",
  "#CA3716",
  "#253CF4",
  "#5DD50B",
  "#B81486",
  "#C28F0A",
  "#7723E7",
  "#0AC223",
  "#D50B2A",
  "#145DB8",
  "#99CB0B",
  "#BC0AC2",
  "#16CA90",
  "#C2510A",
  "#3925F4",
  "#35B814",
  "#D50B6E",
  "#0A9AC2",
  "#CABD16",
  "#8C0BD5",
  "#0BD551",
  "#B81D14",
  "#0D44F2",
  "#6CC20A",
  "#CA16AA",
  "#0AC2AD",
  "#D5830B",
  "#642CE8",
  "#0BD50D",
  "#C20A3E",
  "#167DCA",
  "#A9C20A",
  "#B50BD5",
  "#14B86E",
  "#D5400B",
  "#252CF4",
  "#51CA16",
  "#C20A7B",
  "#0BC3D5",
  "#B89714",
  "#7C0CE9",
  "#0AC232",
  "#CA1624",
  "#0B52CB",
  "#90D50B",
  "#B814B0",
  "#0BD5A4",
  "#C2600A",
  "#5030E8",
  "#20C20A"
];
